const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-4 text-center">
        <p className="text-gray-400 mb-2">
          © {new Date().getFullYear()} Your Name. All rights reserved.
        </p>
        <p className="text-gray-500 text-sm">
          Built with React + TypeScript + Tailwind CSS
        </p>
      </div>
    </footer>
  )
}

export default Footer
